import React from "react";
import store from "../init/store.js";
import { connect } from "react-redux";
import ConsoleView from "./ConsoleView.js";
import ArenaView from "./ArenaView.js";
import { buildTeamsFromCombatantData } from "./lifecycle/build-teams-from-combatant-data.js";
import { getInitialBattleState } from "./lifecycle/init-battle.js";
import { getNewTurnSeries } from "./lifecycle/start-turn-series.js";
import { handleNewRollout } from "./lifecycle/handle-new-rollout.js";
import {
  setBattleValue,
  setMatchmakingValue
} from "../redux-actions/battle-actions.js";
import { offlineCheckForAutoSubmission } from "./offline/offline-check-for-auto-submissions.js";
import audioManager from "../_audio/audio-manager.js";
import { getQueryVariable } from "../helpers/get-query-variable.js";
//import {getRandomBattleScenario} from './getRandomBattleScenario'
import { getDevScenario } from "./getDevScenario";
import ReportingRunner from "./reporting-mode/ReportingRunner";
import { getQuickBattleScenario } from "./getQuickBattleScenario";

/** Sets any data before mounting the battle arena */
class OfflineBattleContainer extends React.Component {
  /** Load the data for the battle */
  componentWillMount() {
    //Check if we should be in full party control mode or not.
    const controlledCombatantIds = ["main", "oneB", "oneC"];
    //TODO: Hardcoding may become an issue? Not sure.
    //UPDATE: Hardcoding in B5 is going to be a thing, but only for initing battles. No need to hardcode in the future
    //We could arguable get rid of the hardcoding now, but it's not a deep issue.

    //Track the starting time!
    //NOTE: this piece happens separately in Online mode via OnlineBattleContainer
    setBattleValue({
      battleStartTimestamp: Date.now(), //Start time!
    });



    this.initialCombatantData = getQueryVariable("dev")
      ? getDevScenario(controlledCombatantIds)
      : getQuickBattleScenario(controlledCombatantIds);

    //Build teams and set initial state for offline battle
    const teams = buildTeamsFromCombatantData(this.initialCombatantData);
    setBattleValue({
      ...getInitialBattleState(this.initialCombatantData, teams),
      battlePlayerId: controlledCombatantIds
    });

    //Get the "lead" of the enemy team
    const enemyLeadId = teams["two"].combatantIds[0];
    const leadEnemyModel = this.initialCombatantData[enemyLeadId];

    //Just for kicks, set the matchmaking crewNames. This is really only used for Tracking, but maybe we'll want to show the crew names?
    setMatchmakingValue({
      crewNames: {
        [controlledCombatantIds[0]]: store.getState().crew.name,
        [enemyLeadId]: `${leadEnemyModel.name}'s Crew`
      }
    });

    // Set the initial turn order and cloudQueue values
    const initialSeries = getNewTurnSeries();

    setBattleValue({
      seriesTurnOrder: initialSeries.seriesTurnOrder,
      seriesTurnsSubmitters: initialSeries.seriesTurnsSubmitters, //[]
      cloudQueue: initialSeries.cloudQueue,

      arenaTransitionOverlay: {
        transition: "fadeOut",
        callback() {
          //Kick off intro message after fade
          handleNewRollout({
            submitterCombatantId: "BATTLE-SYSTEM",
            rolloutId: "rollout_battle-starting",
            timestamp: Date.now(),
            rolloutPayload: [
              {
                type: "message",
                content: [leadEnemyModel.getIntroMessage()]
              }
            ]
          });
        }
      }
    });
  }

  componentDidMount() {
    //TODO: Maybe move me?
    //Play the battle tune!
    // songRegularBattle.play()
    audioManager.playSong("music_RegularBattle");

    if (this.props.battleViewMode === "reporting") {
      //handled in ReportingRunner
      return;
    }

    //Regular offline console mode...

    //Everything is loaded!
    //Check if we need to auto submit the first action

    offlineCheckForAutoSubmission(); //TODO: I think this will move to after some sort of Intro

    //Otherwise the human player will have a submission menu
  }

  render() {
    if (this.props.battleViewMode === "reporting") {
      return <ReportingRunner />;
    }
    if (this.props.battleViewMode === "arena") {
      return <ArenaView />;
    }
    return <ConsoleView />;
  }
}

export default connect((state, props) => {
  return {
    battleViewMode: state.battle.battleViewMode
  };
})(OfflineBattleContainer);



// WEBPACK FOOTER //
// ./src/battle/OfflineBattleContainer.js